import { useQuery } from "@tanstack/react-query";
import { getRegion } from "../../api/apiCallManager";

// Custom hook for fetching regions
export const useRegions = () => {
  return useQuery({ queryKey: ["regionList"], queryFn: getRegion });
};
